[
    { "abbr": "CZ", "code": "+420", "pos": 2276, "label": "Česko" },
    { "abbr": "SK", "code": "+421", "pos": 6500, "label": "Slovensko" },
    { "abbr": "BE", "code": "+32", "pos": 1316, "label": "Belgie" },
    { "abbr": "BG", "code": "+359", "pos": 1380, "label": "Bulharsko" },
    { "abbr": "HR", "code": "+385", "pos": 3492, "label": "Chorvatsko" },
    { "abbr": "DK", "code": "+45", "pos": 2372, "label": "Dánsko" },
    { "abbr": "EE", "code": "+372", "pos": 2532, "label": "Estonsko" },
    { "abbr": "FI", "code": "+358", "pos": 2724, "label": "Finsko" },
    { "abbr": "FR", "code": "+33", "pos": 2852, "label": "Francie" },
    { "abbr": "GI", "code": "+350", "pos": 3076, "label": "Gibraltar" },
    { "abbr": "IE", "code": "+353", "pos": 3620, "label": "Irsko" },
    { "abbr": "IS", "code": "+354", "pos": 3812, "label": "Island" },
    { "abbr": "IT", "code": "+39", "pos": 3844, "label": "Itálie" },
    { "abbr": "CY", "code": "+357", "pos": 2244, "label": "Kypr" },
    { "abbr": "LI", "code": "+423", "pos": 4452, "label": "Lichtenštejnsko" },
    { "abbr": "LT", "code": "+370", "pos": 4580, "label": "Litva" },
    { "abbr": "LV", "code": "+371", "pos": 4644, "label": "Lotyšsko" },
    { "abbr": "LU", "code": "+352", "pos": 4612, "label": "Lucembursko" },
    { "abbr": "HU", "code": "+36", "pos": 3556, "label": "Maďarsko" },
    { "abbr": "MT", "code": "+356", "pos": 5124, "label": "Malta" },
    { "abbr": "MC", "code": "+377", "pos": 3588, "label": "Monako" },
    { "abbr": "DE", "code": "+49", "pos": 2308, "label": "Německo" },
    { "abbr": "NL", "code": "+31", "pos": 5508, "label": "Nizozemsko" },
    { "abbr": "NO", "code": "+47", "pos": 5540, "label": "Norsko" },
    { "abbr": "PL", "code": "+48", "pos": 5892, "label": "Polsko" },
    { "abbr": "PT", "code": "+351", "pos": 5988, "label": "Portugalsko" },
    { "abbr": "AT", "code": "+43", "pos": 1092, "label": "Rakousko" },
    { "abbr": "GR", "code": "+30", "pos": 3268, "label": "Řecko" },
    { "abbr": "RO", "code": "+40", "pos": 6148, "label": "Rumunsko" },
    { "abbr": "SM", "code": "+378", "pos": 6564, "label": "San Marino" },
    { "abbr": "SI", "code": "+386", "pos": 6468, "label": "Slovinsko" },
    { "abbr": "ES", "code": "+34", "pos": 2660, "label": "Španělsko" },
    { "abbr": "SE", "code": "+46", "pos": 6404, "label": "Švédsko" },
    { "abbr": "GB", "code": "+44", "pos": 2916, "label": "Velká Británie" },
    { "abbr": "US", "code": "+1", "pos": 7332, "label": "Spojené státy" },
    { "abbr": "CA", "code": "+1", "pos": 1796, "label": "Kanada" }
]
